import { render, staticRenderFns } from "./SettingQuiz.vue?vue&type=template&id=41f934f6&scoped=true"
import script from "./SettingQuiz.vue?vue&type=script&lang=js"
export * from "./SettingQuiz.vue?vue&type=script&lang=js"
import style0 from "./SettingQuiz.vue?vue&type=style&index=0&id=41f934f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f934f6",
  null
  
)

export default component.exports